import(/* webpackMode: "eager", webpackExports: ["signOut"] */ "/usr/src/app/node_modules/next-auth/react.js");
;
import(/* webpackMode: "eager", webpackExports: ["ProjectOverviewScreen"] */ "/usr/src/app/src/screens/project-overview/ProjectOverviewScreen.tsx");
;
import(/* webpackMode: "eager" */ "/usr/src/app/src/types/Institution/domain/institution.ts");
